module.exports = __webpack_public_path__ + "img/1531120329.8f796637.jpg";